import { Check } from '@mui/icons-material';
import { Link, Typography, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FC } from 'react';
import { Circle } from '../../../../DealFlow2/components/DealModal/DealAddModalContent/Circle';
import { CenterAlignedCell } from '../Objectives/ObjectiveComponent';
import { UserCell } from '../Objectives/UserCell';
import { ClosedFieldContainer, ClosedSubFormContainer } from './StyledFormComponents';

const DataContainer = styled('div')`
  display: grid;
  grid-template-columns: 55% 35% 10%;
  border-radius: 4px;
`;

interface ObjectiveDataProps {
  name: string;
  ownerId: number;
  onEdit: () => void;
}

export const ObjectiveData: FC<ObjectiveDataProps> = ({ name, ownerId, onEdit }) => {
  const { colors } = useTheme();

  return (
    <ClosedSubFormContainer>
      <Typography component='h6' variant='h6' sx={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
        <Circle isChecked={true} style={{ background: colors.success[20] }}>
          <Check htmlColor={colors.success[60]} />
        </Circle>
        Objective
      </Typography>

      <ClosedFieldContainer>
        <DataContainer>
          <CenterAlignedCell>
            <Typography variant='body2'>{name}</Typography>
          </CenterAlignedCell>
          <CenterAlignedCell>
            <UserCell userId={ownerId} />
          </CenterAlignedCell>
          <CenterAlignedCell>
            <Link component='button' onClick={onEdit} underline={'none'}>
              Edit
            </Link>
          </CenterAlignedCell>
        </DataContainer>
      </ClosedFieldContainer>
    </ClosedSubFormContainer>
  );
};
